import React, { Fragment } from 'react';
import { t } from 'Src/i18n';
import { useTracking } from 'Tracking/tracking-api/useTracking';
import DynamicLink from 'Components/frameworks/dynamic-link/DynamicLink';
import { LineTitle } from 'Components/widgets/line-title/LineTitle';
import { OfferPush } from 'Components/widgets/offers-push/OfferPush';
import { Slider } from 'Components/frameworks/slider/Slider';
import { asRatioDisplay } from 'Src/types/cast-helpers';
import { OFFER_STYLE, RATIO_DISPLAYS } from './image.constants';
const TRACKING = {
  actionGA: 'push_content_offers',
  labelGA: 'seeMore',
};
export const OffersPushLineNarrow = ({
  title,
  seeMoreLabel,
  seeMoreLink,
  columns,
}: CMSOffersPush) => {
  const track = useTracking(TRACKING);
  return (
    <Fragment>
      {!!title && <LineTitle>{title}</LineTitle>}
      <div className="-mx-20 w-screen">
        <Slider
          cols={0}
          hasControls={false}
          navPosition="center"
          nbItemsToScroll={1}
          nextLabel={t('common.next')}
          previousLabel={t('common.previous')}
          scrollAreaContainerClassName="gap-20 px-20 lg:px-0 scrollbar-hidden scroll-x scroll-smooth"
          scrollControlsClassName="-mx-20 lg:mx-0"
        >
          {columns.map((columnProps, index) => (
            <div className={OFFER_STYLE} key={index}>
              <OfferPush
                {...columnProps}
                id={index + 1}
                ratioDisplay={asRatioDisplay(RATIO_DISPLAYS)}
              />
            </div>
          ))}
        </Slider>
      </div>

      {seeMoreLabel && seeMoreLink && (
        <DynamicLink
          className="mx-auto mt-15 block text-center text-14 text-black underline hocus:text-black-active"
          onClick={() => track()}
          url={seeMoreLink}
        >
          {seeMoreLabel}
        </DynamicLink>
      )}
    </Fragment>
  );
};
